import { Fragment } from 'react'
import { MoneyFormat } from '../../../../widgets/NumberFormat'

const PartimeSalayFullTimeSalaryListView = ({ PayrollList }) => {
    let totals = {
        salary_with_s_kosh: 0,
        part_tot_salary :0,
        total :0
    };

    PayrollList?.data?.forEach(emp => {
        totals.salary_with_s_kosh += ((emp?.basic_tot_salary * 16 / 100) + (emp?.allowance_amt + emp?.basic_tot_salary)) || 0;
        totals.part_tot_salary += ((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)-(((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)*1/100);
        totals.total += ((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)-(((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)*1/100)+Number(emp?.allowance_amt + emp?.basic_tot_salary) - (emp?.basic_tot_salary * 15 / 100)- emp?.hit_kosh;
    });
 
    return (
        <Fragment>
            <div className='bg-white dark:bg-slate800 shodow rounded-md p-2'>
                <div className="relative w-full overflow-x-auto">
                    <table className="w-full text-sm whitespace-nowrap text-left rtl:text-right text-slate700 dark:text-slate400">
                        <thead className="text-[11px] top-0 sticky z-10 font-public-sans text-slate800 capitalize border-b dark:bg-slate700 bg-slate200 dark:text-slate100 dark:border-slate700">
                            <tr>
                                <th scope="col" className="px-2 py-0.5 border border-slate300 dark:border-gray-700 w-10">
                                    S.N.
                                </th>
                                <th scope="col" className="px-2 bg-slate200 sticky left-0 py-0.5 border border-slate300 dark:border-gray-700">
                                    Emp Name
                                </th>
                                <th scope="col" className="px-2 py-0.5 border border-slate300 dark:border-gray-700">
                                    Designation
                                </th>
                                <th scope="col" className="px-2 py-0.5 border border-slate300 dark:border-gray-700">
                                   Part Tot. Salary
                                </th>
                                
                                <th scope="col" className="px-2 py-0.5 border border-slate300 dark:border-gray-700">
                                    Receivable Amount
                                </th>
                                <th scope="col" className="px-2 py-0.5 border border-slate300 dark:border-gray-700">
                                    Total Amount
                                </th>
                            </tr>
                            
                        </thead>
                        <tbody>
                            {
                                Array.isArray(PayrollList?.data) && PayrollList?.data?.length > 0 ? (PayrollList?.data?.map((emp, index) => (
                                    <tr key={index} className="bg-white hover:bg-slate100 hover:cursor-pointer text-[11px] font-public-sans dark:bg-slate800 text-slate800 dark:hover:bg-slate600">
                                        <td align='center' className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                            {index + 1}.
                                        </td>
                                        <td className="px-2 py-0.5 capitalize sticky left-0 bg-white border border-slate300 dark:border-slate700 italic">
                                            {`${emp?.first_name ? emp?.first_name : ""} ${emp?.middle_name ? emp?.middle_name : ""} ${emp?.last_name ? emp?.last_name : ""}`}
                                        </td>

                                        <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                            {emp?.designation_name}
                                        </td>
                                        <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                            {Number((emp?.basic_tot_salary * 16 / 100) + (emp?.allowance_amt + emp?.basic_tot_salary)).toFixed(2)}
                                        </td>
                                        <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                            {Number(((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)-(((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)*1/100)).toFixed(2)}
                                        </td>
                                         <td className="px-2 py-0.5 border border-slate300 dark:border-slate700">
                                            {Number(parseFloat((emp?.basic_tot_salary * 16 / 100) + (emp?.allowance_amt + emp?.basic_tot_salary))+parseFloat(((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)-(((emp?.post_allowance + emp?.extra_period + emp?.irre_period+emp?.sem_period+emp?.holiday_thap)-emp?.holiday_katti)*1/100))).toFixed(2)}
                                        </td>
                                       
                                    </tr>
                                ))) : <tr className="bg-white text-[12px] font-public-sans dark:bg-slate800 text-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600">
                                    <td align='center' colSpan={16} className="px-2 py-1 border dark:border-gray-700">
                                        <span>No Payroll Found</span>
                                    </td>
                                </tr>
                                
                            }
                             <tr className="bg-gray-100 text-[10px] dark:bg-gray-800 font-bold font-public-sans">
                                <td colSpan={3} className="px-2 py-0.5 border">Total</td>
                                <td className="px-2 py-0.5 border border-slate300">{MoneyFormat(totals.salary_with_s_kosh)}</td>
                                <td className="px-2 py-0.5 border border-slate300">{MoneyFormat(totals.part_tot_salary)}</td>
                                <td className="px-2 py-0.5 border border-slate300">{MoneyFormat(parseFloat(totals.salary_with_s_kosh) + parseFloat(totals.part_tot_salary))}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </Fragment>
    )
}

export default PartimeSalayFullTimeSalaryListView